import React from "react";
import classNames from "classnames";
import classes from "./HotspotIcon.module.scss";

const HotspotIcon = ({
  isSelected,
  left,
  top,
  onClick,
  className,
  innerRef,
}) => (
  <button
    ref={innerRef}
    type="button"
    className={classNames(classes.hotspot__icon, className, {
      [classes.selected]: isSelected,
    })}
    style={{ left, top }}
    onClick={onClick}
  >
    <span className={classes.inner} />
    <span className={`${classes.inner} ${classes.innerVertical}`} />
  </button>
);

export default HotspotIcon;
